import styled from 'styled-components';

export interface CaseStatusProps {
  bgcolor: string;
}

export const CaseStatus = styled.div<{ bgcolor: string }>`
  background-color: ${(props) => props.bgcolor};
  font-family: ${(props) =>
    props.theme.atlas.typography.semantic.bodySmall.fontFamily};
  color: ${(props) => props.theme.atlas.semantic.color.surface.default};
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 5px 18px 6px;
  border-radius: 8px;
  font-weight: 500;
  font-size: 10px;
  line-height: 11px;
  width: fit-content;
  text-transform: capitalize;
`;

export default CaseStatus;
